import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import LoadingScreen from '../../hoc/LoadingScreen';

const vehicle = (props) => {

  const vehicleTypesSelect = props.vehicleTypes.map(el => {
    return (
      <option key={"vehicle-type-"+el.id} value={el.id}>{el.name}</option>
    )
  });

  const vehicleMakesSelect = props.vehicleMakes.map(el => {
    return (
      <option key={"vehicle-make-"+el.id} value={el.id}>{el.name}</option>
    )
  });

  return (
    <LoadingScreen isLoading={props.isLoading} text={props.loadingTxt}>
      <Row className="justify-content-md-center">
        <Col xs={12}>
          <Form>
            <Form.Group>
              <Form.Label><i className="fa fa-car"></i> Sisestage sõiduki andmed</Form.Label>

              <Row>
                <Col xs={12} md={6} className="mb-2 mb-md-0">
                  <Form.Control 
                    className={
                      props.data.data.type.isValid!==null ?
                        props.data.data.type.isValid===true? "is-valid" : "is-invalid"
                      : null
                    }
                    name="trumpauto-car-type"
                    autoComplete='false'
                    as="select" value={props.data.data.type.value??"0"} onChange={(e) => props.fieldChanged("type", e)}>

                    <option value="0">Vali sõidukiliik {props.isTypeRequired?"*":""}</option>

                    {vehicleTypesSelect}

                  </Form.Control>
                </Col>

                <Col xs={12} md={6} className="mb-2 mb-md-0">
                  <Form.Control 
                    className={
                      props.data.data.make.isValid!==null ?
                        props.data.data.make.isValid===true? "is-valid" : "is-invalid"
                      : null
                    }
                    name="trumpauto-car-make"
                    autoComplete='false'
                    as="select" value={props.data.data.make.value??"0"} onChange={(e) => props.fieldChanged("make", e)}>

                    <option value="0">Vali mark {props.isMakeRequired?" *":""}</option>

                    {vehicleMakesSelect}

                    <option value="-1">Muu</option>

                  </Form.Control>

          
                </Col>
                
              </Row>
              <Row className="mt-2">
              <Col xs={12} md={6} className="mb-2 mb-md-0">
                  <Form.Control 
                  className={
                    props.data.data.model.isValid!==null ?
                      props.data.data.model.isValid===true? "is-valid" : "is-invalid"
                    : null
                  }
                    name="car-model" placeholder={"Mudel" + (props.isMakeRequired?" *":"")}
                    value={props.data.data.model.value??""} 
                    onChange={(e) => props.fieldChanged("model", e)} />

                </Col>
                <Col xs={12} md={6} className="mb-2 mb-md-0">
                  <Form.Control 
                    className={
                      props.data.data.regNo.isValid!==null ?
                        props.data.data.regNo.isValid===true? "is-valid" : "is-invalid"
                      : null
                    }
                    name="car-reg-no" placeholder={"Reg. nr" + (props.isRegNoRequired?" *":"")}
                    value={props.data.data.regNo.value??""} 
                    onChange={(e) => props.fieldChanged("regNo", e)} />

                </Col>
              </Row>
            </Form.Group>

          </Form>
        </Col>
      </Row>
    </LoadingScreen>
  );
};

export default vehicle;